<template>
  <div class="section-title-wrap">
    <em class="section-title-bg"></em>
    <h3 class="section-title" :class="[dzgTitleTempClass]">
      <span v-if="isAntslg" class="ico left"></span>
      {{ title }}
      <span v-if="isAntslg" class="ico right"></span>
    </h3>
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: ['title'],
  computed: {
    isAntslg() {
      // 标题左右需要有icon的游戏id
      return [2, 263].includes(+this.$store.state.gameId);
    },
    gameId() {
      return this.$store.state.gameId;
    },
    dzgTitleTempClass() {
      // 2024.9.19 针对大掌柜韩、日 顶部banner上标题进行特殊处理
      // 以UTC+0时间为准，判断当前时间是否在活动结束时间之前
      const currentUTCTime = new Date().toISOString();
      // 限时活动结束时间
      const targetTime = '2024-09-27T14:59:59Z'; // 相当于日韩时间2024-09-27 23:59:59
      if (currentUTCTime < targetTime) {
        if (+this.gameId === 209 || +this.gameId === 211) {
          return 'dzg-temp';
        }
      }
      return '';
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';
.section-title-wrap {
  position: relative;
  width: 100%;
}
.section-title-bg {
  display: block;
  position: relative;
  margin: 0 auto;
  @psetbg ('title-bg.png');
}
.section-title {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  background-size: cover;
  line-height: 38px;
  text-align: center;
  font-weight: bold;
  font-size: 40px;
  color: var(--section-title);
  transform: translate(-50%, -50%);
}
.choose-role-title {
  .dzg-temp {
    color: #ebd190;
  }
}
</style>
